import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import "./index.scss";
import NavBar from "../../components/Navbarr";
import SideBarAdmin from "../../components/SideBarAdmin";
import Footerr from "../../components/Footerr";
import AccessDenied from "../../components/AccessDenied";
import { UserContext } from "../../components/context/userContext";
import Modal from "react-modal";
import ModalCategorie from "../../components/ModalCategorie";
import { getCategories } from "../../services/get-categories";
import { toast } from "react-toastify";
import { addCategorie } from "../../services/post-add-categorie";
import { updateCategorie } from "../../services/put-categorie";
import { deleteCategorie } from "../../services/delete-categorie";
import ModalViderBasket from "../../components/ModalViderBasket";
import Lottie from "react-lottie";

import { defaultOptionsLoading } from "../../assets/lottie-animations/animationOptions";
const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Change the background color and opacity here
  },
  content: {
    top: "40%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    height: "50vh",
    borderWidth: 0.2,
    borderRadius: 12,

    background: "#fff",
  },
};

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useLayoutEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
function Categories() {
  const { user, token } = useContext(UserContext);
  const { height, width } = useWindowDimensions();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [categorieToEdit, setCategorieToEdit] = useState<any>();
  const [openDeleteModal, setOpenDeletModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [loading, setLoading] = useState(false);
  const openEditMode = (categorie: any) => {
    setCategorieToEdit(categorie);
    setIsOpen(true);
  };
  function openModal() {
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
  }
  function closeDeleteModal() {
    setOpenDeletModal(false);
  }

  const doAddCategorie = (values) => {
    addCategorie(values, user?._id)
      .then((response) => {
        if (response?.status === 500) {
        }
        if (!response?.success) {
          toast.error(response?.message);
        }
        if (response?.success) {
          toast.success("categorie added successfuly !");
          doGetCategories();
          closeModal();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const doGetCategories = () => {
    setLoading(true);
    getCategories()
      .then((response) => {
        setLoading(false);

        if (response?.status === 500) {
          toast.error("Internal Server Error !");
        }
        if (!response?.success) {
          toast.error(response?.message);
        }
        if (response?.success) {
          setCategories(response?.content);
        }
      })
      .catch((error) => {
        setLoading(false);

        toast.error(error);
      });
  };

  const doUpdateCategorie = (values) => {
    updateCategorie(categorieToEdit?._id, user?._id, values)
      .then((response) => {
        if (response?.status === 500) {
          toast.error("Internal Server Error !");
        }
        if (!response?.success) {
          toast.error(response?.message);
        }
        if (response?.success) {
          toast.success("categorie updated successfuly !");
          doGetCategories();
          closeModal();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const doDeleteCategorie = () => {
    deleteCategorie(itemToDelete?._id, user?._id, token)
      .then((response) => {
        if (response?.status === 500) {
          toast.error("Internal Server Error !");
        }
        if (!response?.success) {
          toast.error(response?.message);
        }
        if (response?.success) {
          toast.success("categorie deleted successfuly !");
          doGetCategories();
          closeDeleteModal();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  useEffect(() => {
    doGetCategories();
  }, []);

  return (
    <>
      {user?.role == 1 ? (
        <div>
          <div>
            <NavBar />
          </div>
          <div className="dashboard-container">
            <div className="side-bar-container">
              <SideBarAdmin widthWindow={width} screen={"categories"} />
            </div>
            <div className="body-container">
              <div className="header-body">
                <div className="header-left">
                  <h2>Categories</h2>
                </div>
                <button
                  className="add-categorie-btn"
                  onClick={() => openModal()}
                >
                  Ajouter <i className="bx bx-plus"></i>
                </button>
              </div>
              <div className="line" />
              {loading ? (
                <div className="admin-loader">
                  <Lottie
                    options={defaultOptionsLoading}
                    height={150}
                    width={150}
                  />
                </div>
              ) : (
                <div className="boxes-container">
                  {categories?.length > 0 ? (
                    categories?.map((categorie, index) => (
                      <div className="one-box-content" key={categorie?._id || index}>
                        <div className="box-actions">
                          <i
                            className="bx bx-edit icon-action"
                            title="Edit"
                            onClick={() => openEditMode(categorie)}
                          ></i>
                          <i
                            className="bx bx-trash icon-action danger"
                            title="Delete"
                            onClick={() => {
                              setItemToDelete(categorie);
                              setOpenDeletModal(true);
                            }}
                          ></i>
                        </div>
                        <div className="box-body">
                          <span className="box-title">
                            {categorie?.categoryName}
                          </span>
                          <span className="box-meta">
                            {categorie?.subCategories?.length} subcategories
                          </span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="boxes-empty">No categories found</div>
                  )}
                </div>
              )}
            </div>
          </div>
          <div>
            <Footerr />
          </div>
        </div>
      ) : (
        <div>
          <div>
            <NavBar />
          </div>
          <div className="dashboard-container">
            <AccessDenied />
          </div>
          <div>
            <Footerr />
          </div>
        </div>
      )}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
        <ModalCategorie
          closeModal={closeModal}
          doGetCategories={doGetCategories}
          doAdd={doAddCategorie}
          addType={"categorie"}
          categoriesData={[]}
          setSelectedOption={null}
          selectedOption={null}
          categorieToEdit={categorieToEdit}
          setCategoryToEdit={setCategorieToEdit}
          doUpdateCategorie={doUpdateCategorie}
        />
      </Modal>
      <Modal
        isOpen={openDeleteModal}
        onRequestClose={closeDeleteModal}
        style={customStyles}
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
        <ModalViderBasket
          text={`Êtes-vous sûr de vouloir supprimer ${itemToDelete?.categoryName} ?`}
          closeModal={closeDeleteModal}
          action={doDeleteCategorie}
        />
      </Modal>
    </>
  );
}

export default Categories;
